import React from 'react';
import background from '../../assets/clam.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoClam extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="OCEANS"
        description="Bivalves"
        paragraph="Bivalve mollusks filter food through their gills. Heavy metals and toxin-laden microplastics can accumulate in the digestive tract. This  starves the organism and makes it unsafe for human consumption. "
        background={background}
     />
  
  );
 }
}   

export default InfoClam;